import { AquaWidgetElement } from './element'

export { mount } from './element'
export type { AquaWidgetOptions, AquaWidgetInstance, Mode } from './element'
export { AquaApi, AquaApiError } from './api'

if (typeof customElements !== 'undefined' && !customElements.get('aqua-widget')) {
  customElements.define('aqua-widget', AquaWidgetElement)
}
